import styled from 'styled-components';
import { rgba } from 'polished';
import { COLOR_WHITE, COLOR_ORANGE } from '../../assets/styles/colors';

// Banner background: linear-gradient(to bottom, #434162, #403e5b 33%, #38364e)
export const AccessCardSC = styled.div`
  background-image: linear-gradient(to bottom, #434162, #403e5b 33%, #38364e);
  color: ${COLOR_WHITE};
  border-radius: 32px;
  padding: 80px 64px 64px 64px;
  margin: 96px auto 64px auto;
  max-width: 1200px;
  min-width: 400px;
  box-shadow: 0 16px 48px 0 #2f2e41;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  border: 3px solid ${rgba(COLOR_WHITE, 0.08)};

  h2 {
    color: ${COLOR_ORANGE};
    font-size: 2rem;
    font-weight: 900;
    margin-bottom: 80px;
    letter-spacing: 1px;
    text-shadow: 0 4px 16px rgba(47,46,65,0.18);
  }
  p {
    color: ${COLOR_WHITE};
    font-size: 1.15rem;
    margin-bottom: 64px;
    line-height: 1.1;
    text-shadow: 0 2px 8px rgba(47,46,65,0.10);
    font-weight: 400;
  }
  p:last-child {
    font-weight: 700;
    margin-top: 64px;
    font-size: 1.25rem;
    margin-bottom: 0;
  }

  @media (max-width: 900px) {
    padding: 40px 16px 32px 16px;
    max-width: 98vw;
    min-width: unset;
    h2 { font-size: 1.1rem; margin-bottom: 40px; }
    p, p:last-child { font-size: 0.6rem; }
    p { margin-bottom: 32px; }
    p:last-child { margin-top: 32px; }
  }
`;
